import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceEstablishmentChoiceManualEntryProposalsClientAcceptProps {
  proposalId: string;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceEstablishmentChoiceManualEntryProposalsClientAccept = ({
  proposalId,
  options,
}: UseMaintenanceEstablishmentChoiceManualEntryProposalsClientAcceptProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceManualEntryProposalsClientAccept'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/establishment_choice/manual_entry_proposals/${proposalId}/client_accept`);
    },
    ...options
  });
}
